import './login';
import './dashboard';
import { dbh_kalender } from '../Controls/dbh_kalender';
import { dbh_helper } from '../src/dbh_helper';

let timeoutCalenderResize = null;
$(document).ready(function () {
    if (dbh_helper.getUrlArea() == "index" || dbh_helper.getUrlArea() == "") {
        var k = new dbh_kalender();
        k.computeCalendar();

        $(window).on("resize", () => {
            if (timeoutCalenderResize !== null) {
                clearTimeout(timeoutCalenderResize);
            }
            timeoutCalenderResize = setTimeout(function () {
                k.computeCalendar();
            }, 500);
        });
    }
});